import { routeabsheader } from "./mainabstract";

interface IRouteAbsHeader {
    routeAbstractHeader: routeabsheader;
}
export const IndentAbstractHeader = (props: IRouteAbsHeader) => {
  const { routeAbstractHeader } = props;
  return (
    <tr style={{ border: "1px solid #E5E4E2", backgroundColor: "#E5E4E2", borderRadius:"5px"  }}>
      {/* <th>{routeAbstractHeader?.col1}</th> */}
      <th>{routeAbstractHeader?.col2}</th>
      <th>{routeAbstractHeader?.col3}</th>
      <th>{routeAbstractHeader?.col4}</th>
      <th>{routeAbstractHeader?.col5}</th>
      <th>{routeAbstractHeader?.col6}</th>
      <th>{routeAbstractHeader?.col7}</th>
      <th>{routeAbstractHeader?.col8}</th>
      <th>{routeAbstractHeader?.col9}</th>
      <th>{routeAbstractHeader?.col10}</th>
      <th  style={{float:"right"}}>{routeAbstractHeader?.col11}</th>
    </tr>
  );
};
